var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDownXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 2.65H13.7308L19.35 8.26924V20.3C19.35 20.8799 18.8799 21.35 18.3 21.35H5.7C5.1201 21.35 4.65 20.8799 4.65 20.3V3.7C4.65 3.1201 5.1201 2.65 5.7 2.65Z",
    stroke: "#505768",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2L20 8V9H13V2H14Z",
    fill: "#505768"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1 14H7L8 16.5L7 19H8.1L8.5 17.7L8.9 19H10L9 16.5L10 14H8.9L8.5 15.3L8.1 14Z",
    fill: "#505768"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14H11V18C11 18.5523 11.4477 19 12 19H14V18H12V14Z",
    fill: "#505768"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14H16C15.1716 14 14.5 14.6716 14.5 15.5V15.7407C14.5 16.4362 15.0638 17 15.7593 17H16C16.2761 17 16.5 17.2239 16.5 17.5C16.5 17.7761 16.2761 18 16 18H15V19H16C16.8284 19 17.5 18.3284 17.5 17.5V17.2593C17.5 16.5638 16.9362 16 16.2407 16H16C15.7239 16 15.5 15.7761 15.5 15.5C15.5 15.2239 15.7239 15 16 15H17V14Z",
    fill: "#505768"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownXls);
export default __webpack_public_path__ + "static/media/icon_down_xls.10112b9103669150d4349f69489e2e58.svg";
export { ForwardRef as ReactComponent };